// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2PGZU","cell":"ColumnAccessor_cell__3PLXX","firstCellAccent":"ColumnAccessor_firstCellAccent__3rMsn"};